import React, { useEffect, useState } from 'react';
import { FaClock, FaExclamationTriangle } from 'react-icons/fa';

function formatRemaining(ms) {
  if (ms <= 0) return '00:00:00';
  const totalSec = Math.floor(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  return [h, m, s].map((n) => String(n).padStart(2, '0')).join(':');
}

export default function SlaCountdown({ deadline, slaHours, tierLabel, className = '' }) {
  const [remaining, setRemaining] = useState(null);

  useEffect(() => {
    if (!deadline) return undefined;
    const tick = () => {
      const ms = new Date(deadline).getTime() - Date.now();
      setRemaining(ms);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [deadline]);

  if (!deadline) return null;

  const expired = remaining != null && remaining <= 0;
  const urgent = remaining != null && remaining > 0 && remaining < 30 * 60 * 1000;

  return (
    <div
      className={`rounded-xl border p-4 ${expired ? 'border-red-300 bg-red-50' : urgent ? 'border-amber-300 bg-amber-50' : 'border-emerald-200 bg-emerald-50'} ${className}`}
    >
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 text-sm font-semibold text-slate-800">
          {expired ? (
            <FaExclamationTriangle className="text-red-600" />
          ) : (
            <FaClock className={urgent ? 'text-amber-600' : 'text-emerald-700'} />
          )}
          <span>
            {expired ? 'SLA expired' : 'Accept within'}
            {tierLabel ? ` · ${tierLabel}` : ''}
            {slaHours ? ` (${slaHours}h)` : ''}
          </span>
        </div>
        <span
          className={`font-mono text-2xl font-bold tabular-nums ${expired ? 'text-red-700' : urgent ? 'text-amber-700' : 'text-emerald-800'}`}
        >
          {formatRemaining(remaining ?? 0)}
        </span>
      </div>
      {expired && (
        <p className="text-xs text-red-700 mt-2">
          Breach processing runs server-side — order may be reassigned or refunded.
        </p>
      )}
    </div>
  );
}
